var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewObjectActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.747 5.8C13.052 2.713 10.36 1.333 8 1.333h-.007c-2.353 0-5.04 1.38-5.74 4.46-.787 3.44 1.32 6.354 3.227 8.194A3.62 3.62 0 0 0 8 15.007c.906 0 1.813-.34 2.513-1.02 1.907-1.84 4.014-4.747 3.233-8.187M9.833 7.833H8.5v1.334c0 .273-.227.5-.5.5a.504.504 0 0 1-.5-.5V7.833H6.167a.504.504 0 0 1-.5-.5c0-.273.226-.5.5-.5H7.5V5.5c0-.273.226-.5.5-.5.273 0 .5.227.5.5v1.333h1.333c.274 0 .5.227.5.5 0 .274-.226.5-.5.5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewObjectActive);
export default __webpack_public_path__ + "static/media/newObjectActive.c1f15282881ff8d29832796afb787322.svg";
export { ForwardRef as ReactComponent };